"use client";

import createSvgIcon from "./utils/createSvgIcon.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("path", {
  d: "M20.69 4.05C18.66 4.73 15.86 5.5 12 5.5c-3.89 0-6.95-.84-8.69-1.43-.64-.22-1.31.26-1.31.95V19c0 .68.66 1.17 1.31.95C5.36 19.26 8.1 18.5 12 18.5c3.87 0 6.66.76 8.69 1.45.65.21 1.31-.27 1.31-.95V5c0-.68-.66-1.16-1.31-.95m-3.41 11.21C15.62 15.1 13.84 15 12 15c-1.87 0-3.63.1-5.28.27-.45.04-.72-.48-.43-.82l2.5-3c.2-.24.57-.24.77 0l1.62 1.94 2.44-2.93c.2-.24.57-.24.77 0l3.32 3.99c.28.34.01.86-.43.81"
}), 'VrpanoRounded');